export default "__VITE_ASSET__3oeYrWLG__"